import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Lazy from '@prisjakt/ui-lazy';
import {
  ProductTabMain,
  ProductTabProperties,
  ProductTabReviews,
  ProductTabStatistics,
} from './sections';
import AdContainer from 'src/components/ads';
import { PageSection } from 'src/components/page';
import ErrorBoundary from 'src/components/error-boundary';
import { delayedScrollIntoView } from './utils';
import { IProductPageTabsProps, TabAnchor } from './types';
import { SectionWrapper } from './styles';

export const ProductTabs: React.FC<IProductPageTabsProps> = props => {
  const { product, recommendations, currentCampaign, trendingProducts } = props;

  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (
      location.hash !== '' &&
      location.hash !== TabAnchor.ALL &&
      firstRender.current
    ) {
      firstRender.current = false;
      const targetElement = document.getElementById(location.hash)!;
      delayedScrollIntoView(targetElement);
    }
  }, [location.hash]);

  if (!product) {
    return null;
  }

  return (
    <>
      <SectionWrapper id={TabAnchor.ALL}>
        <ProductTabMain
          product={product}
          recommendations={recommendations}
          currentCampaign={currentCampaign}
          trendingProducts={trendingProducts}
        />
      </SectionWrapper>

      <SectionWrapper id={TabAnchor.REVIEWS}>
        <ErrorBoundary onError={() => null}>
          <Lazy>
            <ProductTabReviews product={product} />
          </Lazy>
        </ErrorBoundary>
      </SectionWrapper>

      <SectionWrapper id={TabAnchor.STATISTICS}>
        <PageSection noBorder noPad="bottom">
          <AdContainer
            placement="panorama_target"
            format="panorama_3_wde"
            min={861}
            max={10000}
            scalable
            scaleBase=".pj-ui-panel--row"
            spacing={{
              top: '10px',
              bottom: '10px',
            }}
          />

          <AdContainer
            placement="dubbelpanorama3"
            format="panorama_3"
            min={0}
            max={860}
            spacing={{
              top: '10px',
              bottom: '10px',
            }}
          />

          <ErrorBoundary onError={() => null}>
            <Lazy>
              <ProductTabStatistics product={product} />
            </Lazy>
          </ErrorBoundary>
        </PageSection>
      </SectionWrapper>

      <SectionWrapper id={TabAnchor.PROPERTIES}>
        <PageSection noBorder>
          <ErrorBoundary onError={() => null}>
            <Lazy>
              <ProductTabProperties product={product} />
            </Lazy>
          </ErrorBoundary>
        </PageSection>
      </SectionWrapper>
    </>
  );
};
